import Page from './index'

export default [
  {
    path: '/forgot-password',
    element: <Page />
  }
]
